<div class="layer-dialog mat-dialog">
    <mat-dialog-content>
        <div class="content markdown">
            <markdown #markdownElement [src]="layerFormatLink"></markdown>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close>{{ 'close' | tr }}</button>
    </mat-dialog-actions>
</div>
